import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { showNotification } from '@mantine/notifications';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { messagingService } from '@/services/messaging.service';
import type { MessagingUpdateRequest } from '@/types/messaging';

export const useMessaging = (churchId: string | undefined) => {
  return useQuery({
    queryKey: [QUERY_KEYS.MESSAGING, churchId],
    queryFn: () => messagingService.getMessaging(churchId ?? ''),
    enabled: !!churchId,
  });
};

export const useUpdateMessagingMutation = (churchId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: MessagingUpdateRequest) => messagingService.updateMessaging(churchId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.MESSAGING, churchId] });
      showNotification({ title: 'Success', message: 'Messaging updated successfully', color: 'green' });
    },
  });
};
